import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import './index.css';
import {getComponentName} from '../../common/utils/namespace';
import {createNamespace} from '../../common/utils';
import {getScroller} from '../../common/utils/dom';
import {BindObserverMixin} from '../../common/mixins/observe';

var _createNamespace = createNamespace('lazyload'),
    _createNamespace2 = _slicedToArray(_createNamespace, 1),
    b = _createNamespace2[0];

export default {
    mixins: [
        BindObserverMixin(
            function(entries, observer) {
                if (entries[0].isIntersecting) {
                    this.pending = false;
                    this.$emit('resolved');
                    observer.disconnect();
                }
            },
            function() {
                return {
                    root: this.container() || getScroller(this.$el, null),
                    threshold: parseFloat(this.threshold)
                };
            }
        )
    ],
    name: getComponentName('Lazyload'),
    data: function data() {
        return {
            pending: true
        };
    },
    props: {
        container: {
            type: Function,
            default: function _default() {
                return null;
            }
        },
        threshold: {
            type: [Number, String],
            validate: function validate(value) {
                value = parseFloat(value);
                return value >= 0 && value <= 1;
            },
            default: 0.3
        }
    },
    render: function render() {
        var h = arguments[0];
        return h(
            'div',
            {
                class: b(),
                ref: 'root'
            },
            [this.$slots.default, this.pending ? this.$slots.pending : this.$slots.resolved]
        );
    },
    install: function install(Vue) {
        Vue.component(this.name, this);
    }
};
